<template>
  <div class="container-fluid">
    <div class="contents setting">
      <tab />

      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-5"
          role="tabpanel"
          aria-labelledby="pills-5-tab"
        >
          <article class="article-header row">
            <div class="col-12">
              <h5>{{ noticeview.title }}</h5>
            </div>
            <div class="d-flex flex-wrap">
              <div class="col-12 col-sm-6 text-black">
                <span
                  class="icon badge bg-purple"
                  v-if="noticeview.type === '1'"
                >
                  {{ $t("title.setting.notice") }}
                </span>
                <span
                  class="icon badge bg-blue"
                  v-if="noticeview.type === '2'"
                >
                  {{ $t("title.setting.patch") }}
                </span>

                {{ $t("title.setting.by") }} {{ noticeview.regname }}
              </div>
              <div class="d-flex col-12 col-sm-6">
                <div class="ms-auto">
                  <span class="me-2">
                    <i class="material-icons">date_range </i>

                    {{ noticeview.timezone_date | dateformat }}
                  </span>
                  <span>
                    <i class="material-icons">visibility</i>
                    {{ noticeview.cnt | comma }}
                  </span>
                </div>
              </div>
            </div>
          </article>
          <article class="article-attach" v-if="noticeview.filename">
            <a :href="noticeview.download_link">
              <i class="material-icons-outlined">file_download</i>
              <span>{{ noticeview.originname }}</span>
            </a>
          </article>
          <article class="article-body">
            <!-- {{ noticeview.contents }} -->
            <span v-html="noticeview.contents"></span>
          </article>

          <article class="article-footer">
            <div class="prev" :class="!next_post.title && 'no-data'">
              <template v-if="next_post.notice_shop_pk">
                <router-link
                  :to="{
                    name: 'NoticeView',
                    params: { noticeno: next_post.notice_shop_pk },
                  }"
                >
                  <i class="material-icons"> expand_less </i>
                  <span>{{ next_post.title }}</span>
                </router-link>
              </template>
              <template v-else>
                <a @click="_alert($t('text.support.no_prev'))" class="pointer">
                  <i class="material-icons-outlined"> expand_less </i>
                  <span>{{ $t("text.support.no_prev") }}</span>
                </a>
              </template>
            </div>
            <div class="next" :class="!prev_post.title && 'no-data'">
              <template v-if="prev_post.notice_shop_pk">
                <router-link
                  :to="{
                    name: 'NoticeView',
                    params: { noticeno: prev_post.notice_shop_pk },
                  }"
                >
                  <i class="material-icons"> expand_more </i>
                  <span>{{ prev_post.title }}</span>
                </router-link>
              </template>
              <template v-else>
                <a @click="_alert($t('text.support.no_next'))" class="pointer">
                  <i class="material-icons-outlined"> expand_more </i>
                  <span>{{ $t("text.support.no_next") }}</span>
                </a>
              </template>
            </div>
          </article>
          <div class="btn-bottom-wrapper">
            <b-button
              size="xl"
              variant="outline-secondary"
              aria-label="list"
              @click="$router.push({ name: 'Notice' })"
              >{{ $t("button.common.list") }}</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/setting";
import tab from "@/components/setting/Tab";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "NoticeView",
  components: {
    tab,
  },
  data() {
    return {
      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "fit_as_title",
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
      },
      noticeview: {
        type: "",
        title: "",
        date: "",
        cnt: 0,
        contents: "",
        prevno: "",
        prevtitle: "",
        nextno: "",
        nexttitle: "",
      },
      next_post: {},
      prev_post: {},
      noticeno: this.$route.params.noticeno || "",
    };
  },
  methods: {
    get_ownernoticeview() {
      ax.get_ownernoticeview(this.noticeno, this.searchData, (flag, data) => {
        if (flag) {
          this.noticeview = data.noticeview;
          this.next_post = data.next_post;
          this.prev_post = data.prev_post;
        } else {
          alert(data.message);
        }
      });
    },
  },
  created() {
    this.get_ownernoticeview();
  },
  watch: {
    "$route.params": function () {
      this.noticeno = parseInt(this.$route.params.noticeno);
      this.get_ownernoticeview();
    },
  },
  mixins: [myMixin],
};
</script>
